module.exports = __webpack_public_path__ + "img/twitter.3e8e7ee8.png";